module.exports = __webpack_public_path__ + "static/img/xcx.ee3cfa2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xcx.jpg
// module id = LP+S
// module chunks = 1